<template>
  <GoogleTagManagerNoscript />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
  <CoreCookieConsentBanner />
</template>

<script setup lang="ts">
import GoogleTagManagerNoscript from '~/components/analytics/GoogleTagManagerNoscript.vue'
</script>
